import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import SafeUrlAssembler from 'safe-url-assembler';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Carriers } from '../../enum/general-enum';
import { ICarrierKey } from '../../models/carrier-key.interface';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';

@Injectable()
export class CarrierService {
  private cachedCarrierKeys: { carrierCode: string, carrierKey: ICarrierKey }[] = [];

  constructor(private http: HttpClient,
    private apiEndpointService: ApiEndpointService) {
  }

  public getCarrierKey(carrier: Carriers | string): Observable<ICarrierKey[]> {
    const carrierCode = carrier.toString().toLowerCase();
    const cachedCarrierKey = this.cachedCarrierKeys.find(key => key.carrierCode === carrierCode);
    if (!!cachedCarrierKey) {
      return of([cachedCarrierKey.carrierKey]);
    }

    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getCarrierKey'))
      .param('carrierCode', carrierCode)
      .toString();

    // return of({
    //   AccountNumber: '2E696V',
    //   AccessKey: 'FD0CE62182A02F05',
    // });

    return this.http.get<ICarrierKey[]>(endpoint).pipe(
      map(
        (carrierKeys) => {
          this.cachedCarrierKeys.push({
            carrierCode,
            carrierKey: carrierKeys[0],
          });

          return carrierKeys;
        },
      ),
    );
  }

  public clearCache() {
    this.cachedCarrierKeys = [];
  }
}
